export var IdAssetBundleInitialStatic;
(function (IdAssetBundleInitialStatic) {
    IdAssetBundleInitialStatic["FarmBackground_Default"] = "background_default";
    IdAssetBundleInitialStatic["FarmHorizon_Default"] = "horizon_default";
    IdAssetBundleInitialStatic["Cursor_Pointer"] = "cursor32_pointer";
})(IdAssetBundleInitialStatic || (IdAssetBundleInitialStatic = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/static/IdAssetBundleInitialStatic.ts
// module id = 803
// module chunks = 3